import axios from "axios";
import { API } from "../config/BackendUrl";
const tokenurl = `${API}/auction`;

export const CreateAuction = async (data) => {
  const config = {
    method: "post",
    url: `${tokenurl}/create`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const CreateBulkAuction = async (data) => {
  const config = {
    method: "post",
    url: `${tokenurl}/createBulk`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const AddAuctionForLogs = async (data) => {
  const config = {
    method: "post",
    url: `${tokenurl}/add`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const EndAuction = async (auctionId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/end/${auctionId}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
    // data: data,
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const RaiseBidOfAuction = async (auctionId, bidAmount) => {
  const config = {
    method: "get",
    url: `${tokenurl}/raiseBid/${auctionId}/${bidAmount}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return { status: 400 };
  }
};

export const GetAuctionDetails = async (query) => 
  {
  const config = {
    method: "get",
    url: `${tokenurl}/${query}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetAllAuctionOfAuction = async (collectionAddress) => {
  const config = {
    method: "get",
    url: `${tokenurl}/list/collection/${collectionAddress}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetAuctionList = async (params) => {
  try {
    const response = await axios.get(`${tokenurl}/`, {
      params: params,
    });
    // const response = await axios(config);
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetAllOpenAuction = async (auctionId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/list/all/open`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const GetAllCloseAuction = async (auctionId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/list/all/closed`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return error.response.data;
  }
};

export const WithdrawBidOfAuction = async (auctionId) => {
  const config = {
    method: "get",
    url: `${tokenurl}/withdraw/${auctionId}`,
    headers: {
      "Content-Type": "application/json",
      // Authorization: `Bearer ${typeof window !== "undefined" &&
      //     JSON.parse(JSON.stringify(localStorage.getItem("token")))
      //     }`,
    },
  };
  try {
    const res = await axios(config);
    return res.data;
  } catch (error) {
    return { status: 400 };
  }
};

export const convertEpochToDateTime =  (epochTime) => {
  const date = new Date(epochTime * 1000); // Convert to milliseconds
  const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sept', 'Oct', 'November', 'Dec'
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? 'pm' : 'am';
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12; // convert 24-hour format to 12-hour format
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${day} ${month} ${year} at ${formattedHours}:${formattedMinutes} ${ampm}`;
};
